import { ReferralWithScope_UserWithoutId } from './DataStructures';

const OUTBOUND_UNREAD_ALERT_STATUSES = new Set([
  'referral_succeeded_unread',
  'referral_failed_unread',
  'referral_already_customer_unread',
]);

export const isInboundUnreadReferral = (referral: ReferralWithScope_UserWithoutId): boolean =>
  referral.conversation
    ? referral.conversation.viewerHasUnread
    : referral.offererAlertStatus === 'new_referral_unread';

export const isOutboundUnreadReferralUpdate = (
  referral: ReferralWithScope_UserWithoutId
): boolean => {
  if (referral.conversation) {
    return referral.conversation.viewerHasUnread;
  }

  if (typeof referral.referrerAlertStatus !== 'string') {
    return false;
  }

  return OUTBOUND_UNREAD_ALERT_STATUSES.has(referral.referrerAlertStatus);
};

export const getReferralUnreadCount = (referral: ReferralWithScope_UserWithoutId): number => {
  if (referral.conversation) {
    return referral.conversation.viewerUnreadCount;
  }

  return isInboundUnreadReferral(referral) || isOutboundUnreadReferralUpdate(referral) ? 1 : 0;
};

export const getUnreadReferralCount = ({
  inboundReferrals,
  outboundReferrals,
}: {
  inboundReferrals: ReferralWithScope_UserWithoutId[];
  outboundReferrals: ReferralWithScope_UserWithoutId[];
}): number =>
  inboundReferrals.filter(isInboundUnreadReferral).length +
  outboundReferrals.filter(isOutboundUnreadReferralUpdate).length;

export const parseUnreadCount = (value: unknown): number | null => {
  if (typeof value === 'number') {
    return Number.isInteger(value) && value >= 0 ? value : null;
  }

  if (typeof value !== 'string') {
    return null;
  }

  const trimmedValue = value.trim();
  if (!/^\d+$/.test(trimmedValue)) {
    return null;
  }

  const parsed = Number(trimmedValue);
  return Number.isSafeInteger(parsed) ? parsed : null;
};
